// DS: i6.18
import React from 'react';
import IconWrap from '../../IconWrap';
const File = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M19 20a1 1 0 01-1 1H6a1 1 0 01-1-1V4a1 1 0 011-1h9.429L19 7v13zM13 5H7v14h10v-9h-3a1 1 0 01-1-1V5z"
    })));
File.displayName = 'File';
export default File;

//# sourceMappingURL=File.js.map